import * as React from 'react'
import { useDispatch } from 'react-redux'

import { SnackbarProvider } from 'notistack'

import { CssBaseline, Theme, StyledEngineProvider } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { ThemeProvider as StylesThemeProvider } from '@mui/styles'

import * as settingsActions from '../../store/settings/settings.actions'

import SnackbarComponent from '../../shared/components/MessageComponents/SnackbarComponent'

import Env from '../../config/envConfig'
import getAppTheme from '../../config/getAppTheme'

import SelectModule from './SelectModule'

const App: React.FC = () => {
  const dispatch = useDispatch()

  const language = 'de'

  const basePath = Env.restBase
  window.localStorage.setItem('basePath', basePath)

  const theme: Theme = getAppTheme(language)
  dispatch(settingsActions.setTheme(theme))

  return (
    <ThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>
          <SnackbarProvider maxSnack={5}>
            <CssBaseline />
            <SelectModule />
            <SnackbarComponent />
          </SnackbarProvider>
        </StyledEngineProvider>
      </StylesThemeProvider>
    </ThemeProvider>
  )
}

export default App
